// "Our Work" products — categorised per client's Excel (GC website list.xlsx)
// Only products with matching images are shown; more will be added as photos arrive.
const categories = [
  {
    id: "personal-milestone",
    label: "Personal Milestone",
    tagline: "Birthdays, anniversaries and the moments that make a life.",
    products: [
      {
        slug: "up-in-heaven",
        title: "Up In Heaven",
        occasion: "A Tribute",
        description:
          "A very special tribute to the person who lives in all our hearts. Celebrating someone in heaven whose light still shines today — we picked this Lladro lamp as it symbolises them and their presence in all our homes.",
        range: "₹35,000 – ₹40,000",
        image: "/gallery/up-in-heaven.jpeg",
      },
      {
        slug: "official-teen",
        title: "Official Teen",
        occasion: "13th Birthday",
        description:
          "A concept crafted for children entering their teenage years! As teens carry a touch of rebellion, the entire theme of the hamper was — CAUTION!!",
        range: "₹30,000 – ₹40,000",
        image: "/gallery/official-teen.jpeg",
      },
      {
        slug: "50th-birthday",
        title: "50th Birthday",
        occasion: "Milestone",
        description:
          "A hamper created for a loved one's 50th birthday, incorporating their favourite things so that everything inside resonates uniquely with them and makes them feel seen.",
        range: "₹10,000 – ₹12,000",
        image: "/gallery/50th-birthday.jpeg",
      },
      {
        slug: "5-decades",
        title: "5 Decades",
        occasion: "50 Years Celebrated",
        description:
          "Five beautifully curated boxes, each representing a decade of life's journey. Together, they celebrate 50 years of memories, milestones, relationships and achievements, telling the story of a life well lived.",
        range: "₹70,000 – ₹90,000",
        image: "/gallery/5-decades.jpeg",
      },
      {
        slug: "emily-in-paris",
        title: "Emily in Paris",
        occasion: "Themed Hamper",
        description:
          "An Emily in Paris inspired curation — chic, elegant, romantic and full of Parisian charm.",
        range: "₹25,000 – ₹30,000",
        image: "/gallery/emily-in-paris.jpeg",
      },
      {
        slug: "the-proposal",
        title: "The Proposal",
        occasion: "20th Anniversary",
        description:
          "A gift curated to recreate their proposal for their 20th anniversary and take them down memory lane — where it all began.",
        range: "₹20,000 – ₹30,000",
        image: "/gallery/the-proposal.jpeg",
      },
      {
        slug: "coffee-love",
        title: "Coffee Love",
        occasion: "For Coffee Lovers",
        description:
          "A warm, aromatic celebration of all things coffee — beans, brews and the rituals around them.",
        range: "₹15,000 – ₹20,000",
        image: "/gallery/coffee-love.jpeg",
      },
      {
        slug: "travels-memories",
        title: "Travels & Memories",
        occasion: "Wanderlust",
        description:
          "A keepsake hamper for the traveller — a love letter to passport stamps and stories collected along the way.",
        range: "₹15,000 – ₹25,000",
        image: "/gallery/travels-memories.jpeg",
      },
      {
        slug: "baby-jungle",
        title: "Baby Jungle",
        occasion: "Baby Shower",
        description:
          "A playful jungle themed celebration for a newborn — soft, sweet and full of tiny treasures.",
        range: "₹25,000 – ₹35,000",
        image: "/gallery/baby-jungle.jpeg",
      },
      {
        slug: "books-coffee",
        title: "Books & Coffee",
        occasion: "Quiet Indulgence",
        description:
          "For the reader who loves their mornings slow — a curation of beautiful books and bespoke coffee.",
        range: "₹10,000 – ₹15,000",
        image: "/gallery/books-coffee.jpeg",
      },
      {
        slug: "spa",
        title: "Spa Hamper",
        occasion: "Pamper",
        description:
          "A curated at-home spa ritual complete with oils, salts, candles and soft moments of self care.",
        range: "₹10,000 – ₹15,000",
        image: "/gallery/spa.png",
      },
      {
        slug: "winter",
        title: "Winter Hamper",
        occasion: "Seasonal",
        description:
          "Cosy textures, warm beverages and seasonal indulgences — a hamper that hugs you in the winter.",
        range: "₹10,000 – ₹20,000",
        image: "/gallery/winter.png",
      },
      {
        slug: "movie-cards",
        title: "Movie & Cards",
        occasion: "Date Night",
        description:
          "Movie night or game night? Why choose — a fun hamper that brings both to the couch.",
        range: "₹15,000 – ₹20,000",
        image: "/gallery/movie-cards.png",
      },
      {
        slug: "tom-and-jerry",
        title: "Tom & Jerry",
        occasion: "Best Friends",
        description:
          "A hamper made specially to depict the love-hate relationship between best friends or even siblings. Someone you can't live with, nor without!",
        range: "₹20,000 – ₹30,000",
        image: "/gallery/tom-and-jerry.jpeg",
      },
      {
        slug: "golf",
        title: "Golf Lover",
        occasion: "For the Golfer",
        description:
          "A thoughtful hamper for the golf enthusiast — from accessories to little luxuries for the course.",
        range: "₹20,000 – ₹30,000",
        image: "/gallery/golf.png",
      },
      {
        slug: "mahjong",
        title: "Mahjong Hamper",
        occasion: "Game Lovers",
        description:
          "An elegant ode to game night — Mahjong sets and refined accompaniments for an evening with friends.",
        range: "₹15,000 – ₹20,000",
        image: "/gallery/mahjong.png",
      },
      {
        slug: "italy",
        title: "A Little Bit of Italy",
        occasion: "Travel Inspired",
        description:
          "A taste of Italian fashion, food and joie de vivre — wrapped into one giant elegant hamper.",
        range: "₹5,000 – ₹7,000",
        image: "/gallery/italy.jpeg",
      },
      {
        slug: "bar",
        title: "Bar Hamper",
        occasion: "For Him / For Her",
        description:
          "A sophisticated bar hamper — fine spirits, mixers and the perfect tools for the home bartender.",
        range: "₹50,000 – ₹60,000",
        image: "/gallery/bar.png",
      },
    ],
  },
  {
    id: "weddings-festivals",
    label: "Weddings & Festivals",
    tagline: "Trousseau, tradition and celebrations dressed in their finest.",
    products: [
      {
        slug: "walk-me-down-the-aisle",
        title: "Walk Me Down the Aisle",
        occasion: "Weddings",
        description:
          "For the hand that has always been there to help you, even down the aisle — a hamper to shower your parents with love and the sweetest way of asking if they will walk you down the aisle.",
        range: "₹20,000 – ₹30,000",
        image: "/gallery/walk-me-down-the-aisle.jpeg",
      },
      {
        slug: "parents-of-the-bride",
        title: "Parents of the Bride",
        occasion: "Weddings",
        description:
          "For the woman who guided and moulded you into their mini-me — a hamper to express how grateful you are to your mother who has always been by your side.",
        range: "₹20,000 – ₹30,000",
        image: "/gallery/parents-of-the-bride.jpeg",
      },
      {
        slug: "luxury-basket",
        title: "Luxury Basket",
        occasion: "Premium Hamper",
        description:
          "An heirloom-worthy luxury basket — finest finds nested in textured, elegant wrappings.",
        range: "₹3,000 – ₹5,000",
        image: "/gallery/luxury-basket.png",
      },
      {
        slug: "trousseau",
        title: "Fun Trousseau Trays",
        occasion: "Weddings",
        description:
          "Playful, modern trousseau trays for weddings — reimagining tradition with personality and style.",
        range: "₹5,000 – ₹7,000 per tray",
        image: "/gallery/trousseau.png",
      },
      {
        slug: "paan-dan",
        title: "Paan Dan Hamper",
        occasion: "Traditional",
        description:
          "A nod to tradition — a beautifully curated Paan Dan hamper, with regal touches and timeless charms.",
        range: "₹10,000 – ₹15,000",
        image: "/gallery/paan-dan.png",
      },
      {
        slug: "luxury-packaging",
        title: "Luxury Packaging",
        occasion: "Signature Packaging",
        description:
          "Our signature luxe packaging — bespoke boxes, fabrics, ribbons and seals that elevate any gift.",
        range: "₹3,000 – ₹5,000",
        image: "/gallery/luxury-packaging.png",
      },
      {
        slug: "hangover-kit",
        title: "Hangover Kit",
        occasion: "Cocktail Party",
        description:
          "A smartly curated hamper for those who may have had a little too much fun at the cocktail party.",
        range: "₹1,200 – ₹1,500 per kit",
        image: "/gallery/hangover-kit.jpeg",
      },
      {
        slug: "mumbai",
        title: "Mumbai Meri Jaan",
        occasion: "City Love",
        description:
          "A heartfelt love letter to Mumbai — its flavours, its icons, its irrepressible spirit.",
        range: "₹5,000 per tray",
        image: "/gallery/mumbai.png",
      },
    ],
  },
  {
    id: "corporate-brand",
    label: "Corporate & Brand Relations",
    tagline: "Thoughtful gifting that speaks for your brand.",
    products: [
      {
        slug: "welcome-to-india-kit",
        title: "Welcome to India Kit",
        occasion: "Corporate Welcome",
        description:
          "A hamper with all the essentials needed to survive in the chaotically beautiful, bustling city of Mumbai!",
        range: "₹10,000 – ₹15,000",
        image: "/gallery/welcome-to-india-kit.jpeg",
      },
      {
        slug: "breakfast",
        title: "Breakfast Hampers",
        occasion: "Mornings",
        description:
          "A breakfast in bed kind of hamper — artisanal jams, freshly baked goods and beautiful linens.",
        range: "₹10,000 – ₹15,000",
        image: "/gallery/breakfast.png",
      },
      {
        slug: "lux-coffee",
        title: "Lux Coffee Hamper",
        occasion: "Premium Coffee",
        description:
          "A luxury coffee experience curated for the connoisseur — single-origin beans, beautiful brewing tools.",
        range: "₹15,000 – ₹20,000",
        image: "/gallery/lux-coffee.png",
      },
      {
        slug: "champagne",
        title: "Champagne Hamper",
        occasion: "Celebrations",
        description:
          "Bubbles, glassware and elegant accompaniments — for every reason to celebrate.",
        range: "₹20,000 – ₹30,000",
        image: "/gallery/champagne.png",
      },
      {
        slug: "chocolates",
        title: "Chocolates",
        occasion: "Sweet Surprise",
        description:
          "An elegant assortment of fine chocolates, beautifully packaged for the indulgent at heart.",
        range: "₹5,000 – ₹10,000",
        image: "/gallery/chocolates.png",
      },
      {
        slug: "festive-stories",
        title: "Festive Stories",
        occasion: "Festive Season",
        description:
          "A festive hamper that tells a story — rich textures, traditional motifs and joyful indulgences.",
        range: "₹3,000 – ₹5,000",
        image: "/gallery/festive-stories.png",
      },
      {
        slug: "office-essentials",
        title: "Office Essentials",
        occasion: "Workspace",
        description:
          "A curation of premium vegan leather products for the workspace — a conscious, cruelty-free choice.",
        range: "₹2,000 – ₹4,000",
        image: "/gallery/office-essentials.jpeg",
      },
      {
        slug: "chai-pe-charcha",
        title: "Chai Pe Charcha",
        occasion: "Heartfelt Conversations",
        description:
          "A hamper created for those who have always sat by you and had heartfelt discussions along with laughter.",
        range: "₹20,000 – ₹30,000",
        image: "/gallery/chai-pe-charcha.jpeg",
      },
      {
        slug: "experience-india",
        title: "Experience India with All Your Senses",
        occasion: "Corporate Welcome",
        description:
          "A hamper that brings India alive through all five senses — taste, touch, sight, smell and sound — each curated to tell the story of a culture, beautifully reimagined.",
        range: "₹20,000 – ₹30,000",
        image: "/gallery/experience-india.jpeg",
      },
      {
        slug: "diwali-sweetness",
        title: "Diwali Sweetness",
        occasion: "Festive Season",
        description:
          "A festive Diwali hamper wrapped in marigolds and gold — traditional sweets and warm wishes for a happy, prosperous new year.",
        range: "₹3,000 – ₹5,000",
        image: "/gallery/diwali-sweetness.jpeg",
      },
      {
        slug: "corporate-packaging",
        title: "Corporate Packaging",
        occasion: "Brand Gifting",
        description:
          "Bespoke corporate packaging at scale — each box hand-wrapped in organza and finished with signature tassels, carrying your brand with elegance.",
        range: "₹2,500 and above",
        image: "/gallery/corporate-packaging.jpeg",
      },
      {
        slug: "exhibition-takeaways",
        title: "Exhibition Takeaways",
        occasion: "Events & Exhibitions",
        description:
          "Thoughtful branded takeaways like custom coasters — small keepsakes that carry your message home from every event.",
        range: "₹1,500 – ₹2,000",
        image: "/gallery/exhibition-takeaways.jpeg",
      },
    ],
  },
];

export default categories;
